import { useEffect } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';
import { QueryClientProvider } from '@tanstack/react-query';
import maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

import TranslationsProvider from '@utils/i18n/i18n';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import Cookies from '@utils/Cookies/Cookies';

import routes from '@App/app.routes';
import store from '@App/app.store';
import translator from '@App/app.translator';

import { QUERY_CLIENT } from '@services/query.service';

import theme from '@style/theme.json';

import 'react-simple-keyboard/build/css/index.css';
import './app.css';

function AppRoutes() {
  return useRoutes(routes);
}

const isMuseumMode = import.meta.env.VITE_APP_MODE === 'museum'
  || import.meta.env.VITE_IS_MUSEUM === 'true';

function App() {
  useEffect(() => {
    document.documentElement.setAttribute('data-app-initialised', true)
    const protocol = new Protocol();
    maplibregl.addProtocol('pmtiles', protocol.tile);
  }, []);

  return (
    <QueryClientProvider client={QUERY_CLIENT}>
      <StoreProvider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <ErrorBoundary>
              <TranslationsProvider translator={translator}>
                <AppRoutes />
                {!isMuseumMode && <Cookies useConfig />}
              </TranslationsProvider>
            </ErrorBoundary>
          </BrowserRouter>
        </ThemeProvider>
        <WindowObserver />
      </StoreProvider>
    </QueryClientProvider>
  );
}

export default App;
